import styled from 'styled-components'
import SummaryCardList from './SummaryCardList'
import ParticipationRateCard from './common/ParticipationRateCard'

const Container = styled.div`
  width: 100%;
  margin-bottom: 36px;
`

const ReportSummaryBoard = ({ data }) => {
  return (
    <Container>
      <SummaryCardList data={data}/>
      <ParticipationRateCard child={data.participation}/>
    </Container>
  )
}

export default ReportSummaryBoard
